import { render, staticRenderFns } from "./monthlyCollectionList.vue?vue&type=template&id=d6291766"
import script from "./monthlyCollectionList.vue?vue&type=script&lang=js"
export * from "./monthlyCollectionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports